import React from 'react';
import PropTypes from 'prop-types';
import CustomerSupportEmail from './CustomerSupportEmails';
import CustomerSupportCall from './CustomerSupportCall';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';
import { environmentProperties } from 'app/util/environmentProperties';

const HELP_SERVER_URL = environmentProperties.helpBaseUrl + '/Flare/newsdesk/US/en_US/Content/Home.htm';

class CustomerSupportBox extends React.PureComponent {
    render() {
        const boxClassNames = classNames('customer-support', this.props.className);
        return (
            <div className={boxClassNames}>
                <div className="customer-support__header">
                    <h3 className="customer-support__header-title">{this.props.t('common:customerSupport.title')}</h3>
                    {!this.props.hideHelp && this.renderHelp()}
                </div>
                <div className="customer-support__content">
                    <CustomerSupportCall />
                    <CustomerSupportEmail />
                </div>
            </div>
        );
    }

    renderHelp() {
        return (
            <a className="customer-support__header-link" href={HELP_SERVER_URL} target="_blank" rel="noreferrer">
                {this.props.t('common:customerSupport.help')}
                <i className="customer-support__header-link-icon fo-icon fo-icon-ExternalLink" />
            </a>
        );
    }
}

CustomerSupportBox.propTypes = {
    className: PropTypes.string,
    hideHelp: PropTypes.bool
};

export default withTranslation(['common'])(CustomerSupportBox);
